import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AppProvider } from './app/AppContext';
import { createDefaultServices } from './app/services';
import { createE2EServices } from './app/e2e';
import { App } from './App';
import './index.css';

const services =
  (import.meta as unknown as { env: { VITE_E2E?: string } }).env.VITE_E2E === 'true'
    ? createE2EServices()
    : createDefaultServices();

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <HelmetProvider>
      <AppProvider services={services}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AppProvider>
    </HelmetProvider>
  </StrictMode>,
);
